import { defineWorkflow } from './workflow-builder'

/** WF-TOB-02 (Tobacco RM Return) — TL 12B WF-TOB-02 §1–§8 [C]. */
export const WF_TOBRTN = defineWorkflow({
  no: 8,
  code: 'WF-TOB-02',
  name: 'Tobacco RM Return Workflow',
  entity: 'rm_tobacco_return',
  statuses: [
    ['TOB_RTN_DRAFT', 'Draft', true, false, '#64748B', 'Draft pengembalian sisa tembakau oleh Produksi'],
    [
      'TOB_RTN_PENDING_CHECK',
      'Menunggu Pengecekan',
      false,
      false,
      '#F59E0B',
      'Material tiba di pos RM, menunggu verifikasi Admin'
    ],
    [
      'TOB_RTN_CHECKED',
      'Disetujui & Dicetak Stiker',
      false,
      false,
      '#06B6D4',
      'Fisik disetujui, stiker tercetak, tugas putaway dibuat'
    ],
    ['TOB_RTN_PUTAWAY', 'In Storage', false, true, '#10B981', 'Tembakau ditaruh di rak penyimpanan'],
    ['TOB_RTN_REJECTED', 'Ditolak', false, true, '#EF4444', 'Pengembalian ditolak Admin RM']
  ],
  actors: [
    ['ACT_TOB_RTN_PRODUKSI', 'Tim Produksi', 'tim_produksi', { created_by: { _eq: '$CURRENT_USER.id' } }],
    ['ACT_TOB_RTN_ADMIN_RM', 'Admin WH RM', 'admin_wh_rm', null],
    ['ACT_TOB_RTN_OP_RM', 'Operator WH RM', 'operator_wh_rm', null],
    ['ACT_TOB_RTN_SPV_RM', 'WH RM Supervisor', 'wh_rm_supervisor', null]
  ],
  components: [
    ['CMP_TOB_RTN_SUBMIT', 'Tombol Kirim Laporan Pengembalian', 'ACTION', { color: '#3B82F6', variant: 'primary' }],
    ['CMP_TOB_RTN_ACCEPT', 'Tombol Terima & Cetak Stiker', 'ACTION', {}],
    ['CMP_TOB_RTN_REJECT', 'Tombol Tolak Pengembalian', 'ACTION', {}],
    ['CMP_TOB_RTN_STORE', 'Tombol Selesai Putaway', 'ACTION', {}],
    ['CMP_TOB_RTN_PANEL_HEADER', 'Panel Header Pengembalian Tembakau', 'PANEL', {}],
    ['CMP_TOB_RTN_PANEL_ITEMS', 'Panel Rincian Sak & Bobot', 'PANEL', {}]
  ],
  actions: [
    ['ACT_TOB_RTN_SEND', 'TOB_RTN_DRAFT', 'TOB_RTN_PENDING_CHECK', 'CMP_TOB_RTN_SUBMIT', false, false, null],
    ['ACT_TOB_RTN_VERIFY', 'TOB_RTN_PENDING_CHECK', 'TOB_RTN_CHECKED', 'CMP_TOB_RTN_ACCEPT', false, false, null],
    ['ACT_TOB_RTN_REJ', 'TOB_RTN_PENDING_CHECK', 'TOB_RTN_REJECTED', 'CMP_TOB_RTN_REJECT', true, true, null],
    [
      'ACT_TOB_RTN_FINISH',
      'TOB_RTN_CHECKED',
      'TOB_RTN_PUTAWAY',
      'CMP_TOB_RTN_STORE',
      false,
      false,
      { is_stored: true, stored_at: '$NOW' }
    ]
  ],
  eligibility: [
    ['ACT_TOB_RTN_SEND', 'ACT_TOB_RTN_PRODUKSI'],
    ['ACT_TOB_RTN_VERIFY', 'ACT_TOB_RTN_ADMIN_RM'],
    ['ACT_TOB_RTN_REJ', 'ACT_TOB_RTN_ADMIN_RM'],
    ['ACT_TOB_RTN_FINISH', 'ACT_TOB_RTN_OP_RM']
  ],
  panels: [
    ['CMP_TOB_RTN_PANEL_HEADER', 'TOB_RTN_DRAFT', 'write', 'ACT_TOB_RTN_PRODUKSI'],
    ['CMP_TOB_RTN_PANEL_HEADER', 'TOB_RTN_PENDING_CHECK', 'read', null],
    ['CMP_TOB_RTN_PANEL_HEADER', 'TOB_RTN_PUTAWAY', 'read', null],
    ['CMP_TOB_RTN_PANEL_ITEMS', 'TOB_RTN_DRAFT', 'write', 'ACT_TOB_RTN_PRODUKSI'],
    ['CMP_TOB_RTN_PANEL_ITEMS', 'TOB_RTN_PENDING_CHECK', 'write', 'ACT_TOB_RTN_ADMIN_RM'],
    ['CMP_TOB_RTN_PANEL_ITEMS', 'TOB_RTN_PUTAWAY', 'read', null]
  ],
  emailStatuses: ['TOB_RTN_PENDING_CHECK', 'TOB_RTN_REJECTED']
})

export type TobRtnStatusCode = (typeof WF_TOBRTN.spec.statuses)[number][0]
export type TobRtnActorCode = (typeof WF_TOBRTN.spec.actors)[number][0]
export type TobRtnActionName = (typeof WF_TOBRTN.spec.actions)[number][0]
export const buildWorkflowTobReturnSeed = WF_TOBRTN.build
